__turbopack_context__.v({
  "checked": "radio-module-scss-module__ICf2GG__checked",
  "circle": "radio-module-scss-module__ICf2GG__circle",
  "placeholder": "radio-module-scss-module__ICf2GG__placeholder",
  "radio": "radio-module-scss-module__ICf2GG__radio",
  "wrapper": "radio-module-scss-module__ICf2GG__wrapper",
});
